import { StyleSheet } from "react-native";

export const styles  = StyleSheet.create({
    listItem: {
        padding: '0.5em',
        borderBottomColor: 'rgba(128, 128, 128, 0.2)',
        borderBottomWidth: 1,
    }
})